module.exports = __webpack_public_path__ + "static/Chicory1-49a1542c1c9c8ee63d34866a084f1351.webp";